
import React, {useState ,useEffect} from 'react';
import {Link} from "react-router-dom";

import DomainTablePage from '../../components/domainTablePage.js'
import {TechnologyDomains} from '../../../../server/routes/route-types.js'

import {RtCWEWebsitesPageResult} from '../../../../server/routes/cwe.js'

interface CWEWebsitesProps {
	server: string;
	pageData: unknown;
}

export default function CWEWebsites({server, pageData}: CWEWebsitesProps) {

	let [data, setData] = useState(pageData as RtCWEWebsitesPageResult);

	return (
        <>
            <DomainTablePage 
                domainList={data.TechnologyDomains}
            />
        </>
	)
}
